import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WmComponentsModule } from '@wm/components-base';

import { CustomWidgetContainerDirective } from './custom-widget-container/custom-widget-container.directive';
import { CustomWidgetDirective } from './custom-widget.directive'
const components = [
    CustomWidgetDirective
];

@NgModule({
    imports: [
        CommonModule,
        WmComponentsModule,
        CustomWidgetContainerDirective
    ],
    declarations: [...components],
    exports: [...components, CustomWidgetContainerDirective]
})
export class CustomWidgetModule {
}
